import { api } from "../api";
export const getComissionRules = async () => {
  let url = "/comissionsRules";
  return await api.get(url);
};